import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 bg-cream" data-id="element-127">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-128">
        <ShieldCheck className="w-16 h-16 text-amber-500 mx-auto mb-4" data-id="element-129" />
        <h2 className="text-2xl font-bold text-teal-900 mb-2" data-id="element-130">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="text-stone-600 mb-6" data-id="element-131">
          Si el contenido no coincide con lo que te describimos, te devolvemos
          el 100% de tu dinero.
        </p>
        <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-stone-700" data-id="element-132">
          <span className="bg-white px-3 py-1 rounded-full border border-stone-200" data-id="element-133">
            Devolución del 100%
          </span>
          <span className="bg-white px-3 py-1 rounded-full border border-stone-200" data-id="element-134">
            Sin formularios, sin drama
          </span>
          <span className="bg-white px-3 py-1 rounded-full border border-stone-200" data-id="element-135">
            Sin preguntas incómodas
          </span>
          <span className="bg-white px-3 py-1 rounded-full border border-stone-200" data-id="element-136">
            Tasa de devoluciones: menos del 1%
          </span>
        </div>
      </div>
    </section>;
}